import { Component, Input, OnInit } from '@angular/core';
import { observable, computed } from 'mobx-angular';
import {
  TaskSupplierScheduleStepStore,
  TaskSupplierScheduleStore,
} from './task-supplier-schedule-store';

interface Step {
  name: string;
  schedule: TaskSupplierScheduleStepStore;
}

@Component({
  selector: 'task-supplier-schedule-window',
  templateUrl: './task-supplier-schedule-window.component.html',
  styleUrls: ['./task-supplier-schedule-window.component.scss'],
})
export class TaskSupplierScheduleWindowComponent implements OnInit {
  @Input() @observable store: TaskSupplierScheduleStepStore;

  @Input() isDropOff: Boolean = false;

  ngOnInit() {}
}
